import { create } from 'zustand';

type IsConfirmBtnDisabledStore = {
    isDisabled: boolean;
    reason: string | null;
    setState: (state: { isDisabled: boolean; reason: string | null }) => void;
};
export const useConfirmBtnDisabledStore = create<IsConfirmBtnDisabledStore>((set) => ({
    isDisabled: false,
    reason: null,
    setState: (state) => set(state),
}));